import api from './axios';

/**
 * Phase C — pinned-messages API wrappers.
 */
export const listPinnedRequest = (threadId) =>
  api.get(`/chat/threads/${threadId}/pinned`);
export const pinMessageRequest = (threadId, messageId) =>
  api.post(`/chat/threads/${threadId}/messages/${messageId}/pin`);
export const unpinMessageRequest = (threadId, messageId) =>
  api.delete(`/chat/threads/${threadId}/messages/${messageId}/pin`);
